import styled from 'styled-components';

import { mediaQueryLaptopMin } from '@/styleUtils';

const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  order: 1;

  @media all and ${mediaQueryLaptopMin} {
    width: 300px;
    order: 2;
  }
`;

export default Wrapper;
